/* Presentation only: cart requests and inventory remain owned by each form. */
window.EGAtcFeedback = (() => {
  const states = new WeakMap();

  function clear(button) {
    const state = states.get(button);
    if (!state) return;
    clearTimeout(state.timer);
    state.overlay.remove();
    if (state.label === null) button.removeAttribute('aria-label');
    else button.setAttribute('aria-label', state.label);
    button.removeAttribute('aria-busy');
    delete button.dataset.egAtcState;
    states.delete(button);
  }

  function show(button, status, message) {
    if (!button) return;
    clear(button);
    // Purple Dot rewrites descendants containing "Adding". Render that label
    // through CSS so its inventory label observer leaves feedback untouched.
    const overlay = document.createElement('eg-atc-feedback');
    overlay.className = 'eg-atc-feedback';
    overlay.setAttribute('aria-hidden', 'true');
    if (status === 'pending') {
      const spinner = document.createElement('i');
      spinner.className = 'eg-atc-feedback__spinner';
      overlay.append(spinner);
    }
    overlay.dataset.message = message;
    states.set(button, { overlay, label: button.getAttribute('aria-label') });
    button.dataset.egAtcState = status;
    button.setAttribute('aria-label', message);
    button.setAttribute('aria-busy', status === 'pending' ? 'true' : 'false');
    button.append(overlay);
  }

  function clearError(button) {
    if (button?.nextElementSibling?.classList.contains('eg-atc-error')) {
      button.nextElementSibling.remove();
    }
  }

  return {
    pending(button) {
      if (!button) return;
      clearError(button);
      show(button, 'pending', 'Adding…');
    },
    idle(button) {
      if (button?.dataset.egAtcState === 'pending') clear(button);
    },
    success(button) {
      if (!button) return;
      show(button, 'success', 'Added');
      states.get(button).timer = setTimeout(() => clear(button), 2200);
    },
    error(button, message) {
      if (!button) return;
      clear(button);
      clearError(button);
      const error = document.createElement('span');
      error.className = 'eg-atc-error';
      error.setAttribute('role', 'alert');
      error.textContent = message || 'Unable to add this item. Please try again.';
      button.after(error);
    },
    clearError,
  };
})();
